<div class="gh-siv-section">
  <div class="gh-siv-top-bar">
    <div class="gh-siv-title section-title">
      <ui-icon uiTheme="fill" uiType="links" uiTooltipTitle="{{ 'links' | localize }}" class="fs-16px sp-mr-10"></ui-icon>
      <h3>{{ "related_items" | localize }}</h3>

      <!-- TODO: https://gtmhub.atlassian.net/browse/GVS-13052 -->
      <button *ngIf="!hasViewOnlyRole" ui-button uiType="link" uiSize="small" (click)="addRelatedItem()">+ Add item</button>
      <ui-icon *ngIf="hasViewOnlyRole" uiTheme="outline" uiType="info" [uiTooltipTitle]="tooltipTitle" uiTooltipPlacement="right" class="sp-ml-10"></ui-icon>
    </div>
  </div>
</div>

<!-- TODO: THIS WILL BE REMOVED AND REPLACED WITH UI-LIST COMPONENT WHEN IS MIGRATED -->
<div *ngIf="treeNodes.length" class="sp-mt-20 sp-mb-20">
  <div ui-dropdown uiTrigger="click" [uiDropdownMenu]="treeMenu" class="hov-cursor-p">Select Objective or Key Result</div>
  <ui-dropdown-menu #treeMenu="uiDropdownMenu">
    <ul ui-menu>
      <ui-tree [uiData]="treeNodes" (uiClick)="onNodeClick($event)"> </ui-tree>
    </ul>
  </ui-dropdown-menu>
</div>

<related-item-row *ngFor="let relatedItem of relatedItems" [relatedItem]="relatedItem" (updateLinkOption)="updateLink($event)" (deleteRelatedItem)="deleteLink($event)"></related-item-row>
